export {compose} from 'redux';



// WEBPACK FOOTER //
// ./src/utils/compose/index.ts